import { useParams } from 'react-router-dom';
import { useProfileData } from '../../hooks/profile/useProfileData';
import { useProfileImageHandling } from '../../hooks/profile/useProfileImageHandling';
import { ProfileHeader } from './ProfileHeader';
import { ProfileStats } from './ProfileStats';
import { ProfileDescription } from './ProfileDescription';
import { ProfileTripsGrid } from './ProfileTripsGrid';
import { ProfileErrorState } from './ProfileErrorState';

/**
 * Profile page component - refactored to separate business logic from UI.
 * All business logic is now in custom hooks, making it reusable for React Native.
 */
export const ProfilePage = () => {
  const params = useParams();
  const userId = params['userId'];

  // Business logic hooks (platform-agnostic)
  const { profile, trips, profileDescription, isLoading, error } = useProfileData(userId);
  const { profileImageUrl, handleImageError } = useProfileImageHandling(userId);

  // Error state
  if (error) {
    return <ProfileErrorState />;
  }

  // No user ID provided
  if (!userId) {
    return (
      <div>
        <p>No user id</p>
      </div>
    );
  }

  return (
    <div className="w-full mt-6">
      <ProfileHeader
        profileImageUrl={profileImageUrl}
        username={profile?.username}
        isLoading={isLoading}
        onImageError={handleImageError}
      />

      <ProfileStats
        creationYear={profile?.creationYear}
        tripCount={trips?.length ?? 0}
        isLoadingProfile={isLoading}
        isLoadingTrips={isLoading}
      />

      <ProfileDescription description={profileDescription} isLoading={isLoading} />

      <ProfileTripsGrid trips={trips} isLoading={isLoading} />
    </div>
  );
};
